import { ge } from '../../utils/semver';
export var name = 'closeAndOpen';
export var supports = function (env) {
    return env.isInVideo && ge(env.appVersion, '3.6.2');
};
